
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QuestionTag from "./QuestionTag.vue";
import QuestionContent from "./QuestionContent.vue";
import QuestionContentOld from "./QuestionContentOld.vue";
import { Question } from "@/lib/model/question/question";
import { Answer, Dimension, QuestionScore } from "@/lib/model/exam/result"; //候选人答案内容
import DelExamModal from "../../views/paper/components/del-exam-modal.vue"; //删除框
import ModalTitle from "@/lib/model/exam/modal-title";
import { CompanyConfig } from "@/lib/common/acm";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    QuestionTag,
    QuestionContent,
    DelExamModal,
    QuestionContentOld
  }
})
export default class QuestionCard extends Vue {
  //解决ts不识别refs的方法
  $refs!: { qContent: HTMLFormElement };
  @Prop({
    type: Question,
    required: true
  })
  question!: Question; //题目所有信息

  @Prop({
    type: Boolean,
    default: false
  })
  canSelectFlag!: boolean; //题目是否可选中 --在题库的列表页不可选题

  @Prop({
    type: Boolean,
    default: true
  })
  showMore!: boolean; //展示更多操作

  @Prop({
    type: Boolean,
    default: true
  })
  showTag!: boolean; //展示题型tag

  @Prop({
    type: Boolean,
    default: false
  })
  mark!: boolean; //是否 阅卷页面

  @Prop({
    type: Boolean,
    default: false
  })
  cantEdit!: boolean; //是否 不可编辑试卷

  @Prop({
    type: Boolean,
    default: false
  })
  hideAiScore!: boolean; //是否隐藏ai打分

  @Prop({
    type: Answer,
    default: () => {
      return new Answer();
    }
  })
  answer!: Answer; //候选人回答

  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  selectedQIdList!: any[]; //所有选中题目id

  @Prop({
    type: QuestionScore,
    default: () => {
      return new QuestionScore();
    }
  })
  judge!: QuestionScore; //多打分

  @Prop({ type: Boolean, default: false }) isEditPaper!: boolean; //是否编辑试卷页面-可改分、排序、
  @Prop({ type: Boolean, default: false }) isFSK!: boolean; //富士康
  @Prop({ type: Number, default: 0 }) qIndex!: number; //排序
  @Prop({ type: Boolean, default: false }) showMarkTip!: boolean; //提示未打分
  @Prop({ type: Boolean, default: true }) showChange!: boolean; //是否展示题干变量
  @Prop({ type: Boolean, default: false }) isMarkDimensionScoreFlag!: boolean; //是否展示小维度打分
  @Prop({ type: Boolean, default: false }) marked!: boolean; //是否阅过卷
  @Prop({ type: Boolean, default: false }) isNewAi!: boolean; //是否Aibuilder阅卷
  @Prop({ type: Number, default: 0 }) scoreVersion!: number; //是否新版打分规则
  @Prop() all!: any; //

  // @Watch("answer.scoreHr")
  // marked(n: any, o: any) {
  //   if (this.showMarkTip && !o && n !== undefined) {
  //     this.notMark = false;
  //   }
  // }
  // notMark = true; //提示未打分后仍未填分
  checked = false; //默认未选中
  sortTo = 1; //移至第几
  modalTitle: ModalTitle = new ModalTitle(); //删除框
  showDel = false;
  popShow = false; //排序框
  noAnswer = "未作答";
  preparationTimeList = [
    { text: "不限制", value: -1 },
    { text: "3秒", value: 3 },
    { text: "5秒", value: 5 },
    { text: "10秒", value: 10 },
    { text: "30秒", value: 30 },
    { text: "1分钟", value: 60 },
    { text: "2分钟", value: 120 },
    { text: "3分钟", value: 180 }
  ];
  answerTimeList = [
    { label: "不限制", value: -1 },
    { label: "1分钟", value: 60 },
    { label: "2分钟", value: 120 },
    { label: "3分钟", value: 180 },
    { label: "4分钟", value: 240 },
    { label: "5分钟", value: 300 },
    { label: "6分钟", value: 360 },
    { label: "10分钟", value: 600 },
    { label: "15分钟", value: 900 },
    { label: "20分钟", value: 1200 },
    { label: "30分钟", value: 1800 }
  ];
  showPreTime = 0;
  isQuestionType = true; //是否是常规展示题型   形体检查等不是
  V = vuexStore;

  get isRight() {
    return this.answer.keys.join("、") === this.getRightAnswer();
  }
  //小维度打分
  get isMarkDimensionScore() {
    return (
      this.isMarkDimensionScoreFlag &&
      [6, 8].includes(this.answer.type) &&
      this.answer.dimensionAnswerList.length > 0
    );
  }
  mounted() {
    if ([104, 106, 107, 108, 109].includes(this.question.type)) {
      this.isQuestionType = false;
      return;
    }
    if (this.canSelectFlag) {
      //是否已选
      this.checked =
        this.selectedQIdList.indexOf(this.question.questionId) === -1
          ? false
          : true;
    }
    this.showPreTime = CompanyConfig.getInstance().preparationTime; //是否展示视频题准备时间
  }
  //选中card
  selectCard() {
    if (this.canSelectFlag) {
      this.checked = !this.checked;
      this.$refs.qContent.checkCard();
      this.$emit("selectCard", this.question);
    }
  }
  //选择题正确答案
  getRightAnswer() {
    let t = "";
    this.question.optionList.forEach((d: any, i: number) => {
      t += d.isRight === 1 ? d.key + "、" : "";
    });
    return t.slice(0, t.length - 1);
  }
  //选择题是否正确
  yesOrNo(d: any) {
    if (d.join("、") === this.getRightAnswer()) {
      return `<b class = "ok canHideClass" style="left:0">【正确】</b>`;
    }
    return `<b class = "no canHideClass" style="left:0">【错误】</b>`;
  }
  //填空题答案
  blankAnswer() {
    let t = ``;
    this.answer.blanks.forEach((d: any, i: number) => {
      t += `${i + 1}.（${d}）`;
      t += this.answer.blanksIsRight[i]
        ? `<span class="ok">【正确】</span>`
        : `<span class="no">【错误】</span>`;
    });
    return t;
  }
  //打分触发
  setScore() {
    this.answer.scoreHr = Math.floor(Number(this.answer.scoreHr)); //不要小数
    this.answer.scoreHr =
      Number(this.answer.scoreHr) > Number(this.question.score)
        ? Number(this.question.score)
        : Number(this.answer.scoreHr); //禁止超过最高分
    this.answer.isScored = 1; //已打分
  }
  //小维度打分
  setDimensionScore(item: Dimension) {
    item.scoreHr =
      Number(item.scoreHr) > Number(item.scoreAll)
        ? Number(item.scoreAll)
        : Number(item.scoreHr); //禁止超过最高分
    let s = 0;
    let notScored = 0;
    this.answer.dimensionAnswerList.forEach((d: Dimension) => {
      s += d.scoreHr ?? 0;
      notScored += d.scoreHr === undefined ? 1 : 0;
    });
    this.answer.scoreHr = s; //总分
    this.answer.isScored = notScored === 0 ? 1 : 0; //此题已完整打分
  }
  //多人打分 分数列表处理
  filterScoreList(list: string[]) {
    list.forEach((d, i, arr) => {
      if (!d) {
        arr[i] = "-";
      }
    });
    return list;
  }
  //限制正整数
  setNumberType(a: any, b: any) {
    this.sortTo =
      Number(a.replace(/[^\d]/g, "")) > 0 ? Number(a.replace(/[^\d]/g, "")) : 0;
  }
  //排序
  sort() {
    if (!this.sortTo) {
      this.$message.warning("请输入正整数");
      return;
    }
    this.popShow = false;
    this.$emit("sort", this.sortTo);
  }
  //删除
  del() {
    this.modalTitle.title = "删除";
    this.showDel = true;
  }
  //编辑
  edit() {
    this.$emit("edit");
  }
  //评价插入tag文本
  resultAddText(d: string) {
    this.$emit("resultAddText", d);
  }
  formatTime(second: number) {
    if (second === -1) return "不限制";
    if (second < 60) return second + "秒";
    return Math.floor(second / 60) + "分钟";
  }
  delCancel() {
    this.showDel = false;
  }
  delSuccess() {
    this.$emit("del", this.question);
  }
  pauseOther(id: string, qIndex: string) {
    this.$emit("pauseOther", id, qIndex);
  }
  pauseMe(id: number) {
    this.$refs.qContent.pauseMe(id);
  }
}
